import { render } from "./network-economics.vue?vue&type=template&id=1c2e6bc6"
import script from "./network-economics.vue?vue&type=script&lang=js"
export * from "./network-economics.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__